export default __webpack_public_path__ + "static/media/parallel18.01650810.png";